import React, { useState, useEffect, useRef } from "react";
import { TextField } from "@mui/material";
import { useDebounce } from "../../hooks";

interface SearchInputProps {
  onSearch: (value: string) => void;
  placeholder?: string;
  delay?: number;
}

export function SearchInput({
  onSearch,
  placeholder = "Suchen...",
  delay = 500,
}: SearchInputProps) {
  const [value, setValue] = useState("");
  const debouncedValue = useDebounce(value, delay);
  const onSearchRef = useRef(onSearch);
  onSearchRef.current = onSearch;
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onSearchRef.current(debouncedValue ?? "");
  }, [debouncedValue]);

  return (
    <TextField
      size="small"
      variant="outlined"
      placeholder={placeholder}
      value={value}
      onChange={(e) => setValue(e.target.value.replace(/[<>{}]/g, ""))}
      sx={{ width: 300 }}
    />
  );
}
